<template>
    <span></span>
</template>

<script>
export default {
  name: 'Logout',
  beforeMount () {
    this.$userControl.logout()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Logout.vue